import React from 'react';

const CourseFilter = ({ tags, selectedTag, onSelectTag }) => {
  return (
    <div className="course-filter">
      <button 
        onClick={() => onSelectTag(null)} 
        className={!selectedTag ? 'active' : ''}
      >
        All
      </button>
      {tags.map(tag => (
        <button 
          key={tag} 
          onClick={() => onSelectTag(tag)}
          className={selectedTag === tag ? 'active' : ''}
        >
          {tag}
        </button>
      ))}
    </div>
  );
};

export default CourseFilter;
